export default "__VITE_ASSET__CbmzOcmu__"